import AddResultForms from './AddResultForms';

export default AddResultForms;
